<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="ch-info-component">
      <v-flex xs12>
        <v-card>
          <v-card-title class="head">
            <v-layout row wrap>
              <v-flex xs12>
                <i class="fas fa-user-circle fa-fw"></i>
                <span class="info-name ml-2">{{ (name !== null) ? name : 'None' }}</span>
                <span class="info-id ml-2"><b>[</b> {{ (hotel.name !== null) ? hotel.name : 'None' }} <b>]</b></span>
                <button class="ml-2" @click="copyText">
                  <i class="far fa-clone"></i>
                </button>
                <span class="box">
                  <span class="name">UPDATED</span>
                  <span class="time">{{ updated_at }}</span>
                </span>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="body ch-info-field-border">
            <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-user fa-fw"></i>
                    <span class="ml-2">NAME</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="name"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-envelope-square fa-fw"></i>
                    <span class="ml-2">EMAIL</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="email"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-key fa-fw"></i>
                    <span class="ml-2">PASSWORD</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="ch-input-pwd pt-0"
                      v-model="password"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-calendar-check fa-fw"></i>
                    <span class="ml-2">CREATED AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="created_at"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-file-alt fa-fw"></i>
                    <span class="ml-2">DESCRIPTION</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="desc"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-check-square fa-fw"></i>
                    <span class="ml-2">PERMISSIONS</span>
                  </div>
                  <div class="ch-info-field-body">
                    <div class="form-checkbox-group">
                      <div class="form-checkbox">
                        <div
                          class="checkbox-wrapper"
                          v-for="(permissionItem, index) in permissionItems"
                          :key="permissionItem.id"
                        >
                          <v-checkbox :label="getRoleString(permissionItem)" v-model="permissions[index]" :value="permissionItem"></v-checkbox>
                        </div>
                      </div>
                    </div>
                    <!-- <v-select
                      class="pt-0"
                      :items="permissionItems"
                      v-model="permissions"
                      item-text="getRoleString(permissionItems)"
                      item-value="id"
                      multiple
                      bottom
                    ></v-select> -->
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <div class="btn-wrapper">
              <router-link :to="{name: 'staffs'}">
                <button class="ch-menu-btn ch-menu-backbtn" type="button">
                  <i class="fas fa-angle-left fa-fw"></i>
                  LIST
                </button>
              </router-link>
              <v-spacer></v-spacer>
              <button
                class="save"
                @click="updateStaff"
                :disabled="!isValid"
              >
                <i class="fas fa-save fa-fw"></i>
                <span>SAVE</span>
              </button>
              <button
                class="delete"
                @click="openDeleteDialog"
              >
                <i class="fas fa-times-circle fa-fw"></i>
                <span>DELETE</span>
              </button>
              <!-- NOTE: Delete Dialog -->
              <v-dialog v-model="deleteDialog" max-width="300">
                <v-card>
                  <v-card-title class="headline">Are you sure you want to delete the staff account?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat="flat" @click.native="deleteStaff">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import api from '../../../api';
  import PermissionModel from '../../../permissions';

  export default {
    data() {
      return {
        id: null,
        email: null,
        password: null,
        name: null,
        desc: null,
        hotel: {
          name: null,
        },
        created_at: null,
        updated_at: null,
        permissionIds: [],
        permissionItems: [],
        permissions: [],
        permissionRole: [],
        // NOTE: Dialog
        deleteDialog: false,
        // NOTE: validation
        rules: {
          required: value => !!value || 'Required.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'Invalid e-mail.';
          },
        },
      };
    },
    methods: {
      getStaffDetail() {
        api.getStaffDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            this.hotel = result.data.hotel;
            this.name = result.data.name;
            this.permissionRole = result.data.permissions;
            this.email = result.data.email;
            this.desc = result.data.desc;
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.getHotelPermission();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'staffs' });
          }
        });
      },
      getHotelPermission() {
        api.getHotelPermission(this.hotel.id)
        .then((result) => {
          if (result.status === 200) {
            this.permissionIds = result.data.filter(r => r.type === 'igrms' || r.type === 'staffapp');
            this.permissionItems = result.data.map(obj => obj.role);
            this.permissionSettings();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      updateStaff() {
        // NOTE: 선택된 permission의 role과 일치하는 permission_ids 설정
        const newPermissionArray = [];
        for (let i = 0; i < this.permissions.length; i += 1) {
          for (let j = 0; j < this.permissionIds.length; j += 1) {
            if (this.permissions[i] === this.permissionIds[j].role) {
              newPermissionArray.push(this.permissionIds[j].id);
            }
          }
        }
        const params = {
          name: this.name,
          desc: this.desc,
          password: this.password || undefined,
          permission_ids: newPermissionArray,
        };
        api.updateStaff(this.hotel.id, this.id, params)
        .then((result) => {
          if (result.status === 200) {
            this.hotel = result.data.hotel;
            this.name = result.data.name;
            this.name = result.data.name;
            this.email = result.data.email;
            this.desc = result.data.desc;
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      deleteStaff() {
        const id = {
          hotel_id: this.hotel.id,
          staff_id: this.id,
        };
        api.deleteStaff(id)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Delete';
            this.alertOccur();
            this.$router.push({ name: 'staffs' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      isValid() {
        // NOTE: 비밀번호가 사용되었을 때
        if (this.password !== null) {
          if ((this.name !== '') || (this.password !== '') || (this.desc !== '') || (this.permissions.length !== 0)) {
            return true;
          }
        }
        // NOTE: 비밀번호가 사용되지 않았을 때
        if (this.password === null) {
          return true;
        }
        return false;
      },
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.hotel.name;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
      getRoleString(role) {
        return PermissionModel.getRoleString(role);
      },
      permissionSettings() {
        const newArray = [];
        for (let i = 0; i < this.permissionItems.length; i += 1) {
          for (let j = 0; j < this.permissionRole.length; j += 1) {
            if (this.permissionItems[i] === this.permissionRole[j]) {
              newArray[i] = this.permissionItems[i];
            }
          }
        }
        this.permissions = newArray;
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getStaffDetail();
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/staffs/StaffsDetailInfo.vue